// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kricketot: PokeData = {
  "id": 401,
  "name": "kricketot",
  "height": 3,
  "weight": 22,
  "base_experience": 39,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "pound",
    "tackle",
    "growl",
    "absorb",
    "bide",
    "bug-bite",
    "struggle-bug"
  ],
  "moves": [
    "tackle",
    "growl",
    "bug-bite",
    "pounce",
    "signal-spam",
    "infest",
    "pin-missile",
    "string-shot",
    "heal-order",
    "sticky-web",
    "pin-rush",
    "lunge",
    "bug-buzz"
  ],
  "evolution_chain": {
    "id": 208,
    "item": null,
    "species": [
      {
        "name": "kricketot",
        "order": 431,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kricketune",
        "order": 432,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": 401,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 39,
    "speed": 25,
    "ability_power": 25
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
